import { render } from "./DesignSetExample.vue?vue&type=template&id=0ba15e07&scoped=true"
import script from "./DesignSetExample.vue?vue&type=script&lang=js"
export * from "./DesignSetExample.vue?vue&type=script&lang=js"

import "./DesignSetExample.vue?vue&type=style&index=0&id=0ba15e07&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba15e07"]])

export default __exports__